<template>
  <div id="app" style="height: 100%">
    <router-view/>
  </div>
</template>
<script>
import '@/assets/scrollbar.css'
import '@/assets/theme/index.css'

export default {
  data: function () {
    return {
      retryArr: []
    }
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}

html, body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  min-width: 1365px;
}

body {
  overflow-x: hidden;
}

body, th, td, input, label, select, option, textarea, button, fieldset, legend, pre {
  font-family: "apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif";
}

/*调整element-ui样式*/
.qx-tip {
  max-width: 400px;
}

.el-popover {
  padding: 0;
  min-width: 0;
  background: #fff;
  color: black;
}

.el-select-dropdown__list {
  max-width: 600px;
}

.creative-table-reason-tooltip {
  max-width: 400px;
  word-break: break-all;
}

.popper-qx-list-column label.is-disabled .el-checkbox__label {
  color: #c0c4cc !important;
}

.icon-qx-list-close {
  cursor: pointer;
  color: #d7d7d7;
  font-size: 14px;
}

.el-scrollbar {
  margin-top: 20px;
  margin-bottom: 20px;
}

.el-scrollbar .el-select-dropdown__list {
  padding: 0 !important;
}

.popper-qx-creative-autocomplete .el-scrollbar {
  margin: 0 !important;
}

.creative-select-resource-popover {
  margin-left: 30px !important;
}

.select-account-verify {
  width: 440px;
}

.message-finance-invoice-records {
  top: 150px;
  padding: 10px 15px;
}

.homepage-advertiser-chart-column {
  margin-top: 60px !important;
}
</style>
